export default __webpack_public_path__ + "static/media/pending_actions-default.28efe206.svg";